import React from "react";

export default function BusinessPromoCard() {
  return (
    <div className="w-full py-0 md:py-32 bg-drylight">
      <div className="max-w-6xl mx-auto bg-black rounded-2xl overflow-hidden flex flex-col md:flex-row">
        {/* Left Text Block */}
        {/* Left Text Block */}
        <div className="flex-1 text-white p-10 flex flex-col justify-center">
          <h2 className="text-4xl font-semibold leading-snug mb-6">
            All-in-One AI Platform For Modern Salons
          </h2>
          <p className="text-lg mb-8">
            Accept bookings 24/7. Manage staff schedules effortlessly. Automate
            customer reminders, loyalty programs, and marketing — all in one
            simple platform. Lokalai helps salons work smarter, grow faster, and
            deliver a world-class client experience.
          </p>
          <button className="bg-redlight hover:bg-reddark text-white font-semibold py-3 px-6 rounded-full w-max transition">
            Discover Lokalai
          </button>
        </div>

        {/* Right Image */}
        <div className="flex-1">
          <img
            src="https://images.pexels.com/photos/853427/pexels-photo-853427.jpeg"
            alt="Happy client"
            className="w-full h-full object-cover grayscale"
          />
        </div>
      </div>
    </div>
  );
}
